// extracted by mini-css-extract-plugin
export default {"UserMenu":"UserMenu_UserMenu__gd-OB","UserMenu__Item":"UserMenu_UserMenu__Item__MUNzG","UserMenu__Item--Btn":"UserMenu_UserMenu__Item--Btn__lTd53"};